var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9286 0.000244141C8.51788 0.000244141 0 8.49919 0 18.9668C0 28.4311 6.92787 36.2864 15.9757 37.7061V24.4561H11.1679V18.9668H15.9757V14.7835C15.9757 10.0324 18.7961 7.42026 23.1308 7.42026C25.194 7.42026 27.3518 7.77991 27.3518 7.77991V12.4553H24.9668C22.6197 12.4553 21.8815 13.9128 21.8815 15.4082V18.9668H27.1436L26.2918 24.4561H21.8815V37.7061C26.3418 37.0016 30.4035 34.7258 33.3331 31.2893C36.2627 27.853 37.8674 23.4824 37.8572 18.9668C37.8572 8.49919 29.3394 0.000244141 18.9286 0.000244141Z",
    fill: "url(#paint0_linear_2061_2916)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2061_2916",
    x1: 16.8443,
    y1: 2.49024,
    x2: 36.1408,
    y2: 14.8019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A94904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.188a4e64802b63fb89c4f910559fec7a.svg";
export { ForwardRef as ReactComponent };